<template><div><h1>VUX 2.9.3 发布日志</h1>
<h2><a href="/zh-CN/components/picker.html">Picker</a></h2>
<ul><li>[fix] 修复 fix Uncaught TypeError: Cannot assign to read only property exports of object #3386</li>
</ul>
<h2><a href="/zh-CN/components/selector.html">Selector</a></h2>
<ul><li>[fix] 修复direction=rtl时的中文括号显示异常 #2864</li>
</ul>
<h2><a href="/zh-CN/components/v-chart.html">VChart</a></h2>
<ul><li>[enhance] v-point 可以设置size和shape, v-line 可以设置shape</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX 2.9.3 发布日志 | VUX - 基于 WeUI 和 Vue 的移动端组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// 2.9.3-189.vue?0891e284